module.exports = __webpack_public_path__ + "static/media/U_kaplicky.3850b22f.md";